var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h1',{staticClass:"page_title text_center"},[_vm._v("\n    "+_vm._s(_vm.value)+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }